document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollTrigger);
  const tocItems = document.querySelector(".toc-items");
  const chapters = document.querySelectorAll(".chapter");
  for (i = 0; i < chapters.length; i++) {
    let tocItem = document.createElement("div");
    tocItem.className = `toc-item toc-item-${i + 1}`;
    let progressDiv = document.createElement("div");
    progressDiv.className = `progress progress-${i + 1}`;
    tocItem.appendChild(progressDiv);
    let anchor = document.createElement("a");
    anchor.setAttribute("href", `#section${i + 1}`);
    let paragraph = document.createElement("p");
    let title = chapters[i].dataset.chapter;
    paragraph.innerHTML = title;
    anchor.appendChild(paragraph);
    tocItem.appendChild(anchor);
    tocItems.appendChild(tocItem);
    // HTML example:
    // <div class="toc-item toc-item-1">
    //   <div class="progress progress-1"></div>
    //   <a href="#section1"><p>What is it ?</p></a>
    // </div>
  }

  // Create GSAP tweens
  const tocItemsNumber = tocItems.children.length;
  for (i = 0; i < tocItemsNumber; i++) {
    if (i !== tocItemsNumber - 1) {
      gsap
        .timeline({
          scrollTrigger: {
            // markers: true,
            trigger: `#section${i + 1}`,
            start: "top 20%",
            endTrigger: `#section${i + 2}`,
            end: "top 20%",
            scrub: 0.5,
          },
        })
        .from(`.progress-${i + 1}`, { xPercent: -100 });
    } else {
      // Last element of the list
      gsap
        .timeline({
          scrollTrigger: {
            // markers: true,
            trigger: `#section${i + 1}`,
            start: "top 20%",
            endTrigger: `#section${i + 1}`,
            end: "bottom 20%",
            scrub: 0.5,
          },
        })
        .from(`.progress-${i + 1}`, { xPercent: -100 });
    }
  }
});